"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const firebaseAuth_1 = require("../firebaseAuth");
require("firebaseui/dist/firebaseui.css");
exports.LoginView = react_1.default.memo((props) => {
    console.log('++++ LoginView render');
    const ref = react_1.useRef(null);
    react_1.useEffect(() => {
        const e = ref.current;
        if (e) {
            const request = props.widget.loginRequest;
            const subs = firebaseAuth_1.firebaseLoginStart$(e).subscribe(request.firebaseUser$);
            return () => subs.unsubscribe();
        }
    });
    return (react_1.default.createElement("div", { ref: ref }));
});
